import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiUniversities extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }

    createInStudent(data) {
        return this.client.post(`${this.endPoint}/in-student`, data)
    }
}